/*
 * File: api.js
 * Project: lets-talk-web
 *
 * Created by Brendan Michaelsen on January 31, 2022 at 4:48 PM
 * Copyright © 2022 Let's Talk. All rights reserved.
 *
 * Last Modified: April 8, 2024 at 10:00 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import axios from 'axios';

// Constants
import { CLIENT_VERSION_HEADER, CLIENT_PLATFORM_HEADER } from '../../Constants';


/**
 * API Handler
 */

const api = axios.create({
	baseURL: `${process.env.API_URL}${process.env.API_MOUNT}`,
	withCredentials: true,
});


/**
 * Configure API
 */

api.interceptors.request.use(async (config) => {
	const headers = { ...config.headers };
	headers[CLIENT_VERSION_HEADER] = process.env.PACKAGE_VERSION;
	headers[CLIENT_PLATFORM_HEADER] = 'web';
	return { ...config, headers };
});

api.interceptors.response.use((response) => response, (error) => {
	if (error && error.response && error.response.status === 401 && !(error.response?.config?.url || '').endsWith('/login')) {
		window.location = '/login';
	}
	return Promise.reject(error);
});


/**
 * Exports
 */

export default api;
